class CoreTabs extends HTMLElement {

    constructor() {
        super();
        this.onButtonDown = this.onButtonDown.bind(this);
    }

    connectedCallback() {
        this.$buttons  = this.querySelectorAll('[tab-button]');
        this.$slides    = this.querySelectorAll('[tab-slide]');
        this.$buttons.forEach((el, i) => {
            el.setAttribute('data-index', i);
            el.addEventListener('click', this.onButtonDown);
        })
        const startIndex = this.hasAttribute('selected-index') ? Number(this.getAttribute('selected-index')) : 0;
        this.$slides.forEach((el,i) => {
            el.classList[ i == startIndex ? 'add' : 'remove' ]('is-selected');
        });
        this.$buttons.forEach((el,i) => {
            el.classList[ i == startIndex ? 'add' : 'remove' ]('is-selected');
        });
    }

    disconnectedCallback() {
        this.$buttons.forEach((el, i) => {
            el.removeEventListener('click', this.onButtonDown);
        })
    }

    onButtonDown(e) {
        const index = Number(e.currentTarget.getAttribute('data-index'));
        this.$slides.forEach((el,i) => {
            el.classList[ i == index ? 'add' : 'remove' ]('is-selected');
        });
        this.$buttons.forEach((el,i) => {
            el.classList[ i == index ? 'add' : 'remove' ]('is-selected');
        });
    }

}

customElements.define('core-tabs', CoreTabs);


console.log('<core-tabs> loaded');